/* eslint-disable @typescript-eslint/naming-convention */
export const PURGE_DROPS = "@DROPS/PURGE_DROPS";
export type PURGE_DROPS = typeof PURGE_DROPS;

export const SET_DROP = "@DROPS/SET_DROP";
export type SET_DROP = typeof SET_DROP;
